import { jsx as Y, jsxs as Xt } from "react/jsx-runtime";
import * as z from "react";
import { useRef as qt, useState as $t, useCallback as pn, useEffect as Nt } from "react";
import { c as ht } from "../clsx-OuTLNxxd.js";
import { B as Yt } from "../Button-DIvSLTPg.js";
import { c as Zt } from "../createLucideIcon-WU3cnAkb.js";
import '../Carousel.css';/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gn = Zt("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hn = Zt("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
function yn(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Kt(t) {
  return yn(t) || Array.isArray(t);
}
function Sn() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function _t(t, n) {
  const r = Object.keys(t), s = Object.keys(n);
  if (r.length !== s.length) return !1;
  const i = JSON.stringify(Object.keys(t.breakpoints || {})), e = JSON.stringify(Object.keys(n.breakpoints || {}));
  return i !== e ? !1 : r.every((o) => {
    const a = t[o], c = n[o];
    return typeof a == "function" ? `${a}` == `${c}` : !Kt(a) || !Kt(c) ? a === c : _t(a, c);
  });
}
function Ut(t) {
  return t.concat().sort((n, r) => n.name > r.name ? 1 : -1).map((n) => n.options);
}
function xn(t, n) {
  if (t.length !== n.length) return !1;
  const r = Ut(t), s = Ut(n);
  return r.every((i, e) => {
    const o = s[e];
    return _t(i, o);
  });
}
function Tt(t) {
  return typeof t == "number";
}
function Pt(t) {
  return typeof t == "string";
}
function bt(t) {
  return typeof t == "boolean";
}
function Qt(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function _(t) {
  return Math.abs(t);
}
function At(t) {
  return Math.sign(t);
}
function dt(t, n) {
  return _(t - n);
}
function bn(t, n) {
  if (t === 0 || n === 0 || _(t) <= _(n)) return 0;
  const r = dt(_(t), _(n));
  return _(r / t);
}
function Cn(t) {
  return Math.round(t * 100) / 100;
}
function mt(t) {
  return pt(t).map(Number);
}
function F(t) {
  return t[yt(t)];
}
function yt(t) {
  return Math.max(0, t.length - 1);
}
function Dt(t, n) {
  return n === yt(t);
}
function Jt(t, n = 0) {
  return Array.from(Array(t), (r, s) => n + s);
}
function pt(t) {
  return Object.keys(t);
}
function Wt(t, n) {
  return [t, n].reduce((r, s) => (pt(s).forEach((i) => {
    const e = r[i], o = s[i], a = Qt(e) && Qt(o);
    r[i] = a ? Wt(e, o) : o;
  }), r), {});
}
function Ot(t, n) {
  return typeof n.MouseEvent < "u" && t instanceof n.MouseEvent;
}
function vn(t, n) {
  const r = {
    start: s,
    center: i,
    end: e
  };
  function s() {
    return 0;
  }
  function i(c) {
    return e(c) / 2;
  }
  function e(c) {
    return n - c;
  }
  function o(c, l) {
    return Pt(t) ? r[t](c) : t(n, c, l);
  }
  return {
    measure: o
  };
}
function gt() {
  let t = [];
  function n(i, e, o, a = {
    passive: !0
  }) {
    let c;
    if ("addEventListener" in i)
      i.addEventListener(e, o, a), c = () => i.removeEventListener(e, o, a);
    else {
      const l = i;
      l.addListener(o), c = () => l.removeListener(o);
    }
    return t.push(c), s;
  }
  function r() {
    t = t.filter((i) => i());
  }
  const s = {
    add: n,
    clear: r
  };
  return s;
}
function In(t, n, r, s) {
  const i = gt(), e = 1e3 / 60;
  let o = null, a = 0, c = 0;
  function l() {
    i.add(t, "visibilitychange", () => {
      t.hidden && d();
    });
  }
  function y() {
    S(), i.clear();
  }
  function m(h) {
    if (!c) return;
    o || (o = h, r(), r());
    const f = h - o;
    for (o = h, a += f; a >= e; )
      r(), a -= e;
    const g = a / e;
    s(g), c && (c = n.requestAnimationFrame(m));
  }
  function u() {
    c || (c = n.requestAnimationFrame(m));
  }
  function S() {
    n.cancelAnimationFrame(c), o = null, a = 0, c = 0;
  }
  function d() {
    o = null, a = 0;
  }
  return {
    init: l,
    destroy: y,
    start: u,
    stop: S,
    update: r,
    render: s
  };
}
function wn(t, n) {
  const r = n === "rtl", s = t === "y", i = s ? "y" : "x", e = s ? "x" : "y", o = !s && r ? -1 : 1, a = y(), c = m();
  function l(d) {
    const {
      height: p,
      width: h
    } = d;
    return s ? p : h;
  }
  function y() {
    return s ? "top" : r ? "right" : "left";
  }
  function m() {
    return s ? "bottom" : r ? "left" : "right";
  }
  function u(d) {
    return d * o;
  }
  return {
    scroll: i,
    cross: e,
    startEdge: a,
    endEdge: c,
    measureSize: l,
    direction: u
  };
}
function ot(t = 0, n = 0) {
  const r = _(t - n);
  function s(l) {
    return l < t;
  }
  function i(l) {
    return l > n;
  }
  function e(l) {
    return s(l) || i(l);
  }
  function o(l) {
    return e(l) ? s(l) ? t : n : l;
  }
  function a(l) {
    return r ? l - r * Math.ceil((l - n) / r) : l;
  }
  return {
    length: r,
    max: n,
    min: t,
    constrain: o,
    reachedAny: e,
    reachedMax: i,
    reachedMin: s,
    removeOffset: a
  };
}
function tn(t, n, r) {
  const {
    constrain: s
  } = ot(0, t), i = t + 1;
  let e = o(n);
  function o(u) {
    return r ? _((i + u) % i) : s(u);
  }
  function a() {
    return e;
  }
  function c(u) {
    return e = o(u), m;
  }
  function l(u) {
    return y().set(a() + u);
  }
  function y() {
    return tn(t, a(), r);
  }
  const m = {
    get: a,
    set: c,
    add: l,
    clone: y
  };
  return m;
}
function En(t, n, r, s, i, e, o, a, c, l, y, m, u, S, d, p, h, f, g) {
  const {
    cross: x,
    direction: I
  } = t, L = ["INPUT", "SELECT", "TEXTAREA"], w = {
    passive: !1
  }, C = gt(), v = gt(), E = ot(50, 225).constrain(S.measure(20)), A = {
    mouse: 300,
    touch: 400
  }, N = {
    mouse: 500,
    touch: 600
  }, M = d ? 43 : 25;
  let H = !1, R = 0, G = 0, tt = !1, Z = !1, K = !1, U = !1;
  function it(b) {
    if (!g) return;
    function P(V) {
      (bt(g) || g(b, V)) && at(V);
    }
    const D = n;
    C.add(D, "dragstart", (V) => V.preventDefault(), w).add(D, "touchmove", () => {
    }, w).add(D, "touchend", () => {
    }).add(D, "touchstart", P).add(D, "mousedown", P).add(D, "touchcancel", B).add(D, "contextmenu", B).add(D, "click", J, !0);
  }
  function q() {
    C.clear(), v.clear();
  }
  function rt() {
    const b = U ? r : n;
    v.add(b, "touchmove", j, w).add(b, "touchend", B).add(b, "mousemove", j, w).add(b, "mouseup", B);
  }
  function st(b) {
    const P = b.nodeName || "";
    return L.includes(P);
  }
  function Q() {
    return (d ? N : A)[U ? "mouse" : "touch"];
  }
  function ut(b, P) {
    const D = m.add(At(b) * -1), V = y.byDistance(b, !d).distance;
    return d || _(b) < E ? V : h && P ? V * 0.5 : y.byIndex(D.get(), 0).distance;
  }
  function at(b) {
    const P = Ot(b, s);
    U = P, K = d && P && !b.buttons && H, H = dt(i.get(), o.get()) >= 2, !(P && b.button !== 0) && (st(b.target) || (tt = !0, e.pointerDown(b), l.useFriction(0).useDuration(0), i.set(o), rt(), R = e.readPoint(b), G = e.readPoint(b, x), u.emit("pointerDown")));
  }
  function j(b) {
    if (!Ot(b, s) && b.touches.length >= 2) return B(b);
    const D = e.readPoint(b), V = e.readPoint(b, x), $ = dt(D, R), X = dt(V, G);
    if (!Z && !U && (!b.cancelable || (Z = $ > X, !Z)))
      return B(b);
    const nt = e.pointerMove(b);
    $ > p && (K = !0), l.useFriction(0.3).useDuration(0.75), a.start(), i.add(I(nt)), b.preventDefault();
  }
  function B(b) {
    const D = y.byDistance(0, !1).index !== m.get(), V = e.pointerUp(b) * Q(), $ = ut(I(V), D), X = bn(V, $), nt = M - 10 * X, W = f + X / 50;
    Z = !1, tt = !1, v.clear(), l.useDuration(nt).useFriction(W), c.distance($, !d), U = !1, u.emit("pointerUp");
  }
  function J(b) {
    K && (b.stopPropagation(), b.preventDefault(), K = !1);
  }
  function k() {
    return tt;
  }
  return {
    init: it,
    destroy: q,
    pointerDown: k
  };
}
function Ln(t, n) {
  let s, i;
  function e(m) {
    return m.timeStamp;
  }
  function o(m, u) {
    const d = `client${(u || t.scroll) === "x" ? "X" : "Y"}`;
    return (Ot(m, n) ? m : m.touches[0])[d];
  }
  function a(m) {
    return s = m, i = m, o(m);
  }
  function c(m) {
    const u = o(m) - o(i), S = e(m) - e(s) > 170;
    return i = m, S && (s = m), u;
  }
  function l(m) {
    if (!s || !i) return 0;
    const u = o(i) - o(s), S = e(m) - e(s), d = e(m) - e(i) > 170, p = u / S;
    return S && !d && _(p) > 0.1 ? p : 0;
  }
  return {
    pointerDown: a,
    pointerMove: c,
    pointerUp: l,
    readPoint: o
  };
}
function Nn() {
  function t(r) {
    const {
      offsetTop: s,
      offsetLeft: i,
      offsetWidth: e,
      offsetHeight: o
    } = r;
    return {
      top: s,
      right: i + e,
      bottom: s + o,
      left: i,
      width: e,
      height: o
    };
  }
  return {
    measure: t
  };
}
function Pn(t) {
  function n(s) {
    return t * (s / 100);
  }
  return {
    measure: n
  };
}
function On(t, n, r, s, i, e, o) {
  const a = [t].concat(s);
  let c, l, y = [], m = !1;
  function u(h) {
    return i.measureSize(o.measure(h));
  }
  function S(h) {
    if (!e) return;
    l = u(t), y = s.map(u);
    function f(g) {
      for (const x of g) {
        if (m) return;
        const I = x.target === t, L = s.indexOf(x.target), w = I ? l : y[L], C = u(I ? t : s[L]);
        if (_(C - w) >= 0.5) {
          h.reInit(), n.emit("resize");
          break;
        }
      }
    }
    c = new ResizeObserver((g) => {
      (bt(e) || e(h, g)) && f(g);
    }), r.requestAnimationFrame(() => {
      a.forEach((g) => c.observe(g));
    });
  }
  function d() {
    m = !0, c && c.disconnect();
  }
  return {
    init: S,
    destroy: d
  };
}
function _n(t, n, r, s, i, e) {
  let o = 0, a = 0, c = i, l = e, y = t.get(), m = 0;
  function u() {
    const w = s.get() - t.get(), C = !c;
    let v = 0;
    return C ? (o = 0, r.set(s), t.set(s), v = w) : (r.set(t), o += w / c, o *= l, y += o, t.add(o), v = y - m), a = At(v), m = y, L;
  }
  function S() {
    const w = s.get() - n.get();
    return _(w) < 1e-3;
  }
  function d() {
    return c;
  }
  function p() {
    return a;
  }
  function h() {
    return o;
  }
  function f() {
    return x(i);
  }
  function g() {
    return I(e);
  }
  function x(w) {
    return c = w, L;
  }
  function I(w) {
    return l = w, L;
  }
  const L = {
    direction: p,
    duration: d,
    velocity: h,
    seek: u,
    settled: S,
    useBaseFriction: g,
    useBaseDuration: f,
    useFriction: I,
    useDuration: x
  };
  return L;
}
function Tn(t, n, r, s, i) {
  const e = i.measure(10), o = i.measure(50), a = ot(0.1, 0.99);
  let c = !1;
  function l() {
    return !(c || !t.reachedAny(r.get()) || !t.reachedAny(n.get()));
  }
  function y(S) {
    if (!l()) return;
    const d = t.reachedMin(n.get()) ? "min" : "max", p = _(t[d] - n.get()), h = r.get() - n.get(), f = a.constrain(p / o);
    r.subtract(h * f), !S && _(h) < e && (r.set(t.constrain(r.get())), s.useDuration(25).useBaseFriction());
  }
  function m(S) {
    c = !S;
  }
  return {
    shouldConstrain: l,
    constrain: y,
    toggleActive: m
  };
}
function An(t, n, r, s, i) {
  const e = ot(-n + t, 0), o = m(), a = y(), c = u();
  function l(d, p) {
    return dt(d, p) <= 1;
  }
  function y() {
    const d = o[0], p = F(o), h = o.lastIndexOf(d), f = o.indexOf(p) + 1;
    return ot(h, f);
  }
  function m() {
    return r.map((d, p) => {
      const {
        min: h,
        max: f
      } = e, g = e.constrain(d), x = !p, I = Dt(r, p);
      return x ? f : I || l(h, g) ? h : l(f, g) ? f : g;
    }).map((d) => parseFloat(d.toFixed(3)));
  }
  function u() {
    if (n <= t + i) return [e.max];
    if (s === "keepSnaps") return o;
    const {
      min: d,
      max: p
    } = a;
    return o.slice(d, p);
  }
  return {
    snapsContained: c,
    scrollContainLimit: a
  };
}
function Dn(t, n, r) {
  const s = n[0], i = r ? s - t : F(n);
  return {
    limit: ot(i, s)
  };
}
function zn(t, n, r, s) {
  const e = n.min + 0.1, o = n.max + 0.1, {
    reachedMin: a,
    reachedMax: c
  } = ot(e, o);
  function l(u) {
    return u === 1 ? c(r.get()) : u === -1 ? a(r.get()) : !1;
  }
  function y(u) {
    if (!l(u)) return;
    const S = t * (u * -1);
    s.forEach((d) => d.add(S));
  }
  return {
    loop: y
  };
}
function Bn(t) {
  const {
    max: n,
    length: r
  } = t;
  function s(e) {
    const o = e - n;
    return r ? o / -r : 0;
  }
  return {
    get: s
  };
}
function Vn(t, n, r, s, i) {
  const {
    startEdge: e,
    endEdge: o
  } = t, {
    groupSlides: a
  } = i, c = m().map(n.measure), l = u(), y = S();
  function m() {
    return a(s).map((p) => F(p)[o] - p[0][e]).map(_);
  }
  function u() {
    return s.map((p) => r[e] - p[e]).map((p) => -_(p));
  }
  function S() {
    return a(l).map((p) => p[0]).map((p, h) => p + c[h]);
  }
  return {
    snaps: l,
    snapsAligned: y
  };
}
function Mn(t, n, r, s, i, e) {
  const {
    groupSlides: o
  } = i, {
    min: a,
    max: c
  } = s, l = y();
  function y() {
    const u = o(e), S = !t || n === "keepSnaps";
    return r.length === 1 ? [e] : S ? u : u.slice(a, c).map((d, p, h) => {
      const f = !p, g = Dt(h, p);
      if (f) {
        const x = F(h[0]) + 1;
        return Jt(x);
      }
      if (g) {
        const x = yt(e) - F(h)[0] + 1;
        return Jt(x, F(h)[0]);
      }
      return d;
    });
  }
  return {
    slideRegistry: l
  };
}
function jn(t, n, r, s, i) {
  const {
    reachedAny: e,
    removeOffset: o,
    constrain: a
  } = s;
  function c(d) {
    return d.concat().sort((p, h) => _(p) - _(h))[0];
  }
  function l(d) {
    const p = t ? o(d) : a(d), h = n.map((g, x) => ({
      diff: y(g - p, 0),
      index: x
    })).sort((g, x) => _(g.diff) - _(x.diff)), {
      index: f
    } = h[0];
    return {
      index: f,
      distance: p
    };
  }
  function y(d, p) {
    const h = [d, d + r, d - r];
    if (!t) return d;
    if (!p) return c(h);
    const f = h.filter((g) => At(g) === p);
    return f.length ? c(f) : F(h) - r;
  }
  function m(d, p) {
    const h = n[d] - i.get(), f = y(h, p);
    return {
      index: d,
      distance: f
    };
  }
  function u(d, p) {
    const h = i.get() + d, {
      index: f,
      distance: g
    } = l(h), x = !t && e(h);
    if (!p || x) return {
      index: f,
      distance: d
    };
    const I = n[f] - g, L = d + y(I, 0);
    return {
      index: f,
      distance: L
    };
  }
  return {
    byDistance: u,
    byIndex: m,
    shortcut: y
  };
}
function kn(t, n, r, s, i, e, o) {
  function a(m) {
    const u = m.distance, S = m.index !== n.get();
    e.add(u), u && (s.duration() ? t.start() : (t.update(), t.render(1), t.update())), S && (r.set(n.get()), n.set(m.index), o.emit("select"));
  }
  function c(m, u) {
    const S = i.byDistance(m, u);
    a(S);
  }
  function l(m, u) {
    const S = n.clone().set(m), d = i.byIndex(S.get(), u);
    a(d);
  }
  return {
    distance: c,
    index: l
  };
}
function Fn(t, n, r, s, i, e, o, a) {
  const c = {
    passive: !0,
    capture: !0
  };
  let l = 0;
  function y(S) {
    if (!a) return;
    function d(p) {
      if ((/* @__PURE__ */ new Date()).getTime() - l > 10) return;
      o.emit("slideFocusStart"), t.scrollLeft = 0;
      const g = r.findIndex((x) => x.includes(p));
      Tt(g) && (i.useDuration(0), s.index(g, 0), o.emit("slideFocus"));
    }
    e.add(document, "keydown", m, !1), n.forEach((p, h) => {
      e.add(p, "focus", (f) => {
        (bt(a) || a(S, f)) && d(h);
      }, c);
    });
  }
  function m(S) {
    S.code === "Tab" && (l = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: y
  };
}
function ft(t) {
  let n = t;
  function r() {
    return n;
  }
  function s(c) {
    n = o(c);
  }
  function i(c) {
    n += o(c);
  }
  function e(c) {
    n -= o(c);
  }
  function o(c) {
    return Tt(c) ? c : c.get();
  }
  return {
    get: r,
    set: s,
    add: i,
    subtract: e
  };
}
function nn(t, n) {
  const r = t.scroll === "x" ? o : a, s = n.style;
  let i = null, e = !1;
  function o(u) {
    return `translate3d(${u}px,0px,0px)`;
  }
  function a(u) {
    return `translate3d(0px,${u}px,0px)`;
  }
  function c(u) {
    if (e) return;
    const S = Cn(t.direction(u));
    S !== i && (s.transform = r(S), i = S);
  }
  function l(u) {
    e = !u;
  }
  function y() {
    e || (s.transform = "", n.getAttribute("style") || n.removeAttribute("style"));
  }
  return {
    clear: y,
    to: c,
    toggleActive: l
  };
}
function Hn(t, n, r, s, i, e, o, a, c) {
  const y = mt(i), m = mt(i).reverse(), u = f().concat(g());
  function S(C, v) {
    return C.reduce((E, A) => E - i[A], v);
  }
  function d(C, v) {
    return C.reduce((E, A) => S(E, v) > 0 ? E.concat([A]) : E, []);
  }
  function p(C) {
    return e.map((v, E) => ({
      start: v - s[E] + 0.5 + C,
      end: v + n - 0.5 + C
    }));
  }
  function h(C, v, E) {
    const A = p(v);
    return C.map((N) => {
      const M = E ? 0 : -r, H = E ? r : 0, R = E ? "end" : "start", G = A[N][R];
      return {
        index: N,
        loopPoint: G,
        slideLocation: ft(-1),
        translate: nn(t, c[N]),
        target: () => a.get() > G ? M : H
      };
    });
  }
  function f() {
    const C = o[0], v = d(m, C);
    return h(v, r, !1);
  }
  function g() {
    const C = n - o[0] - 1, v = d(y, C);
    return h(v, -r, !0);
  }
  function x() {
    return u.every(({
      index: C
    }) => {
      const v = y.filter((E) => E !== C);
      return S(v, n) <= 0.1;
    });
  }
  function I() {
    u.forEach((C) => {
      const {
        target: v,
        translate: E,
        slideLocation: A
      } = C, N = v();
      N !== A.get() && (E.to(N), A.set(N));
    });
  }
  function L() {
    u.forEach((C) => C.translate.clear());
  }
  return {
    canLoop: x,
    clear: L,
    loop: I,
    loopPoints: u
  };
}
function Rn(t, n, r) {
  let s, i = !1;
  function e(c) {
    if (!r) return;
    function l(y) {
      for (const m of y)
        if (m.type === "childList") {
          c.reInit(), n.emit("slidesChanged");
          break;
        }
    }
    s = new MutationObserver((y) => {
      i || (bt(r) || r(c, y)) && l(y);
    }), s.observe(t, {
      childList: !0
    });
  }
  function o() {
    s && s.disconnect(), i = !0;
  }
  return {
    init: e,
    destroy: o
  };
}
function Gn(t, n, r, s) {
  const i = {};
  let e = null, o = null, a, c = !1;
  function l() {
    a = new IntersectionObserver((d) => {
      c || (d.forEach((p) => {
        const h = n.indexOf(p.target);
        i[h] = p;
      }), e = null, o = null, r.emit("slidesInView"));
    }, {
      root: t.parentElement,
      threshold: s
    }), n.forEach((d) => a.observe(d));
  }
  function y() {
    a && a.disconnect(), c = !0;
  }
  function m(d) {
    return pt(i).reduce((p, h) => {
      const f = parseInt(h), {
        isIntersecting: g
      } = i[f];
      return (d && g || !d && !g) && p.push(f), p;
    }, []);
  }
  function u(d = !0) {
    if (d && e) return e;
    if (!d && o) return o;
    const p = m(d);
    return d && (e = p), d || (o = p), p;
  }
  return {
    init: l,
    destroy: y,
    get: u
  };
}
function qn(t, n, r, s, i, e) {
  const {
    measureSize: o,
    startEdge: a,
    endEdge: c
  } = t, l = r[0] && i, y = d(), m = p(), u = r.map(o), S = h();
  function d() {
    if (!l) return 0;
    const g = r[0];
    return _(n[a] - g[a]);
  }
  function p() {
    if (!l) return 0;
    const g = e.getComputedStyle(F(s));
    return parseFloat(g.getPropertyValue(`margin-${c}`));
  }
  function h() {
    return r.map((g, x, I) => {
      const L = !x, w = Dt(I, x);
      return L ? u[x] + y : w ? u[x] + m : I[x + 1][a] - g[a];
    }).map(_);
  }
  return {
    slideSizes: u,
    slideSizesWithGaps: S,
    startGap: y,
    endGap: m
  };
}
function $n(t, n, r, s, i, e, o, a, c) {
  const {
    startEdge: l,
    endEdge: y,
    direction: m
  } = t, u = Tt(r);
  function S(f, g) {
    return mt(f).filter((x) => x % g === 0).map((x) => f.slice(x, x + g));
  }
  function d(f) {
    return f.length ? mt(f).reduce((g, x, I) => {
      const L = F(g) || 0, w = L === 0, C = x === yt(f), v = i[l] - e[L][l], E = i[l] - e[x][y], A = !s && w ? m(o) : 0, N = !s && C ? m(a) : 0, M = _(E - N - (v + A));
      return I && M > n + c && g.push(x), C && g.push(f.length), g;
    }, []).map((g, x, I) => {
      const L = Math.max(I[x - 1] || 0);
      return f.slice(L, g);
    }) : [];
  }
  function p(f) {
    return u ? S(f, r) : d(f);
  }
  return {
    groupSlides: p
  };
}
function Kn(t, n, r, s, i, e, o) {
  const {
    align: a,
    axis: c,
    direction: l,
    startIndex: y,
    loop: m,
    duration: u,
    dragFree: S,
    dragThreshold: d,
    inViewThreshold: p,
    slidesToScroll: h,
    skipSnaps: f,
    containScroll: g,
    watchResize: x,
    watchSlides: I,
    watchDrag: L,
    watchFocus: w
  } = e, C = 2, v = Nn(), E = v.measure(n), A = r.map(v.measure), N = wn(c, l), M = N.measureSize(E), H = Pn(M), R = vn(a, M), G = !m && !!g, tt = m || !!g, {
    slideSizes: Z,
    slideSizesWithGaps: K,
    startGap: U,
    endGap: it
  } = qn(N, E, A, r, tt, i), q = $n(N, M, h, m, E, A, U, it, C), {
    snaps: rt,
    snapsAligned: st
  } = Vn(N, R, E, A, q), Q = -F(rt) + F(K), {
    snapsContained: ut,
    scrollContainLimit: at
  } = An(M, Q, st, g, C), j = G ? ut : st, {
    limit: B
  } = Dn(Q, j, m), J = tn(yt(j), y, m), k = J.clone(), O = mt(r), b = ({
    dragHandler: ct,
    scrollBody: Et,
    scrollBounds: Lt,
    options: {
      loop: St
    }
  }) => {
    St || Lt.constrain(ct.pointerDown()), Et.seek();
  }, P = ({
    scrollBody: ct,
    translate: Et,
    location: Lt,
    offsetLocation: St,
    previousLocation: sn,
    scrollLooper: cn,
    slideLooper: un,
    dragHandler: an,
    animation: ln,
    eventHandler: jt,
    scrollBounds: fn,
    options: {
      loop: kt
    }
  }, Ft) => {
    const Ht = ct.settled(), dn = !fn.shouldConstrain(), Rt = kt ? Ht : Ht && dn, Gt = Rt && !an.pointerDown();
    Gt && ln.stop();
    const mn = Lt.get() * Ft + sn.get() * (1 - Ft);
    St.set(mn), kt && (cn.loop(ct.direction()), un.loop()), Et.to(St.get()), Gt && jt.emit("settle"), Rt || jt.emit("scroll");
  }, D = In(s, i, () => b(wt), (ct) => P(wt, ct)), V = 0.68, $ = j[J.get()], X = ft($), nt = ft($), W = ft($), et = ft($), lt = _n(X, W, nt, et, u, V), vt = jn(m, j, Q, B, et), It = kn(D, J, k, lt, vt, et, o), Bt = Bn(B), Vt = gt(), on = Gn(n, r, o, p), {
    slideRegistry: Mt
  } = Mn(G, g, j, at, q, O), rn = Fn(t, r, Mt, It, lt, Vt, o, w), wt = {
    ownerDocument: s,
    ownerWindow: i,
    eventHandler: o,
    containerRect: E,
    slideRects: A,
    animation: D,
    axis: N,
    dragHandler: En(N, t, s, i, et, Ln(N, i), X, D, It, lt, vt, J, o, H, S, d, f, V, L),
    eventStore: Vt,
    percentOfView: H,
    index: J,
    indexPrevious: k,
    limit: B,
    location: X,
    offsetLocation: W,
    previousLocation: nt,
    options: e,
    resizeHandler: On(n, o, i, r, N, x, v),
    scrollBody: lt,
    scrollBounds: Tn(B, W, et, lt, H),
    scrollLooper: zn(Q, B, W, [X, W, nt, et]),
    scrollProgress: Bt,
    scrollSnapList: j.map(Bt.get),
    scrollSnaps: j,
    scrollTarget: vt,
    scrollTo: It,
    slideLooper: Hn(N, M, Q, Z, K, rt, j, W, r),
    slideFocus: rn,
    slidesHandler: Rn(n, o, I),
    slidesInView: on,
    slideIndexes: O,
    slideRegistry: Mt,
    slidesToScroll: q,
    target: et,
    translate: nn(N, n)
  };
  return wt;
}
function Un() {
  let t = {}, n;
  function r(l) {
    n = l;
  }
  function s(l) {
    return t[l] || [];
  }
  function i(l) {
    return s(l).forEach((y) => y(n, l)), c;
  }
  function e(l, y) {
    return t[l] = s(l).concat([y]), c;
  }
  function o(l, y) {
    return t[l] = s(l).filter((m) => m !== y), c;
  }
  function a() {
    t = {};
  }
  const c = {
    init: r,
    emit: i,
    off: o,
    on: e,
    clear: a
  };
  return c;
}
const Qn = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Jn(t) {
  function n(e, o) {
    return Wt(e, o || {});
  }
  function r(e) {
    const o = e.breakpoints || {}, a = pt(o).filter((c) => t.matchMedia(c).matches).map((c) => o[c]).reduce((c, l) => n(c, l), {});
    return n(e, a);
  }
  function s(e) {
    return e.map((o) => pt(o.breakpoints || {})).reduce((o, a) => o.concat(a), []).map(t.matchMedia);
  }
  return {
    mergeOptions: n,
    optionsAtMedia: r,
    optionsMediaQueries: s
  };
}
function Xn(t) {
  let n = [];
  function r(e, o) {
    return n = o.filter(({
      options: a
    }) => t.optionsAtMedia(a).active !== !1), n.forEach((a) => a.init(e, t)), o.reduce((a, c) => Object.assign(a, {
      [c.name]: c
    }), {});
  }
  function s() {
    n = n.filter((e) => e.destroy());
  }
  return {
    init: r,
    destroy: s
  };
}
function xt(t, n, r) {
  const s = t.ownerDocument, i = s.defaultView, e = Jn(i), o = Xn(e), a = gt(), c = Un(), {
    mergeOptions: l,
    optionsAtMedia: y,
    optionsMediaQueries: m
  } = e, {
    on: u,
    off: S,
    emit: d
  } = c, p = N;
  let h = !1, f, g = l(Qn, xt.globalOptions), x = l(g), I = [], L, w, C;
  function v() {
    const {
      container: O,
      slides: b
    } = x;
    w = (Pt(O) ? t.querySelector(O) : O) || t.children[0];
    const D = Pt(b) ? w.querySelectorAll(b) : b;
    C = [].slice.call(D || w.children);
  }
  function E(O) {
    const b = Kn(t, w, C, s, i, O, c);
    if (O.loop && !b.slideLooper.canLoop()) {
      const P = Object.assign({}, O, {
        loop: !1
      });
      return E(P);
    }
    return b;
  }
  function A(O, b) {
    h || (g = l(g, O), x = y(g), I = b || I, v(), f = E(x), m([g, ...I.map(({
      options: P
    }) => P)]).forEach((P) => a.add(P, "change", N)), x.active && (f.translate.to(f.location.get()), f.animation.init(), f.slidesInView.init(), f.slideFocus.init(k), f.eventHandler.init(k), f.resizeHandler.init(k), f.slidesHandler.init(k), f.options.loop && f.slideLooper.loop(), w.offsetParent && C.length && f.dragHandler.init(k), L = o.init(k, I)));
  }
  function N(O, b) {
    const P = q();
    M(), A(l({
      startIndex: P
    }, O), b), c.emit("reInit");
  }
  function M() {
    f.dragHandler.destroy(), f.eventStore.clear(), f.translate.clear(), f.slideLooper.clear(), f.resizeHandler.destroy(), f.slidesHandler.destroy(), f.slidesInView.destroy(), f.animation.destroy(), o.destroy(), a.clear();
  }
  function H() {
    h || (h = !0, a.clear(), M(), c.emit("destroy"), c.clear());
  }
  function R(O, b, P) {
    !x.active || h || (f.scrollBody.useBaseFriction().useDuration(b === !0 ? 0 : x.duration), f.scrollTo.index(O, P || 0));
  }
  function G(O) {
    const b = f.index.add(1).get();
    R(b, O, -1);
  }
  function tt(O) {
    const b = f.index.add(-1).get();
    R(b, O, 1);
  }
  function Z() {
    return f.index.add(1).get() !== q();
  }
  function K() {
    return f.index.add(-1).get() !== q();
  }
  function U() {
    return f.scrollSnapList;
  }
  function it() {
    return f.scrollProgress.get(f.offsetLocation.get());
  }
  function q() {
    return f.index.get();
  }
  function rt() {
    return f.indexPrevious.get();
  }
  function st() {
    return f.slidesInView.get();
  }
  function Q() {
    return f.slidesInView.get(!1);
  }
  function ut() {
    return L;
  }
  function at() {
    return f;
  }
  function j() {
    return t;
  }
  function B() {
    return w;
  }
  function J() {
    return C;
  }
  const k = {
    canScrollNext: Z,
    canScrollPrev: K,
    containerNode: B,
    internalEngine: at,
    destroy: H,
    off: S,
    on: u,
    emit: d,
    plugins: ut,
    previousScrollSnap: rt,
    reInit: p,
    rootNode: j,
    scrollNext: G,
    scrollPrev: tt,
    scrollProgress: it,
    scrollSnapList: U,
    scrollTo: R,
    selectedScrollSnap: q,
    slideNodes: J,
    slidesInView: st,
    slidesNotInView: Q
  };
  return A(n, r), setTimeout(() => c.emit("init"), 0), k;
}
xt.globalOptions = void 0;
function zt(t = {}, n = []) {
  const r = qt(t), s = qt(n), [i, e] = $t(), [o, a] = $t(), c = pn(() => {
    i && i.reInit(r.current, s.current);
  }, [i]);
  return Nt(() => {
    _t(r.current, t) || (r.current = t, c());
  }, [t, c]), Nt(() => {
    xn(s.current, n) || (s.current = n, c());
  }, [n, c]), Nt(() => {
    if (Sn() && o) {
      xt.globalOptions = zt.globalOptions;
      const l = xt(o, r.current, s.current);
      return e(l), () => l.destroy();
    } else
      e(void 0);
  }, [o, e]), [a, i];
}
zt.globalOptions = void 0;
const Yn = "_carousel_jgwra_1", Zn = "_carouselViewport_jgwra_5", Wn = "_carouselContainer_jgwra_9", te = "_carouselContainerHorizontal_jgwra_13", ne = "_carouselContainerVertical_jgwra_18", ee = "_carouselItem_jgwra_23", oe = "_carouselItemHorizontal_jgwra_30", re = "_carouselItemVertical_jgwra_34", se = "_carouselControl_jgwra_38", ce = "_carouselPreviousButtonHorizontal_jgwra_49", ie = "_carouselNextButtonHorizontal_jgwra_55", ue = "_carouselPreviousButtonVertical_jgwra_61", ae = "_carouselNextButtonVertical_jgwra_67", le = "_controlsOutside_jgwra_73", fe = "_carouselControlIcon_jgwra_86", de = "_srOnly_jgwra_91", me = "_edgeFade_jgwra_103", T = {
  carousel: Yn,
  carouselViewport: Zn,
  carouselContainer: Wn,
  carouselContainerHorizontal: te,
  carouselContainerVertical: ne,
  carouselItem: ee,
  carouselItemHorizontal: oe,
  carouselItemVertical: re,
  carouselControl: se,
  carouselPreviousButtonHorizontal: ce,
  carouselNextButtonHorizontal: ie,
  carouselPreviousButtonVertical: ue,
  carouselNextButtonVertical: ae,
  controlsOutside: le,
  carouselControlIcon: fe,
  srOnly: de,
  edgeFade: me
}, en = z.createContext(null);
function Ct() {
  const t = z.useContext(en);
  if (!t)
    throw new Error("useCarousel must be used within a <Carousel />");
  return t;
}
const pe = z.forwardRef(
  ({
    children: t,
    className: n,
    controlsPosition: r = "inside",
    edgeFade: s = !1,
    hideControlsAtEnds: i = !1,
    opts: e,
    orientation: o = "horizontal",
    plugins: a,
    setApi: c,
    ...l
  }, y) => {
    const [m, u] = zt(
      {
        ...e,
        axis: o === "horizontal" ? "x" : "y"
      },
      a
    ), [S, d] = z.useState(!1), [p, h] = z.useState(!1), f = !!(e != null && e.dragFree) && !(e != null && e.loop), g = z.useCallback(
      (C) => {
        if (C) {
          if (f) {
            const v = C.scrollSnapList().length > 1, E = C.scrollProgress();
            d(v && E > 1e-3), h(v && E < 0.999);
            return;
          }
          d(C.canScrollPrev()), h(C.canScrollNext());
        }
      },
      [f]
    ), x = z.useCallback(() => {
      u == null || u.scrollPrev();
    }, [u]), I = z.useCallback(() => {
      u == null || u.scrollNext();
    }, [u]), L = z.useCallback(
      (C) => {
        C.key === "ArrowLeft" ? (C.preventDefault(), x()) : C.key === "ArrowRight" && (C.preventDefault(), I());
      },
      [x, I]
    );
    z.useEffect(() => {
      !u || !c || c(u);
    }, [u, c]), z.useEffect(() => {
      if (u)
        return g(u), u.on("reInit", g), u.on("select", g), f && u.on("scroll", g), () => {
          u == null || u.off("reInit", g), u == null || u.off("select", g), u == null || u.off("scroll", g);
        };
    }, [u, g, f]);
    const w = z.useMemo(
      () => ({
        carouselRef: m,
        api: u,
        opts: e,
        orientation: o || ((e == null ? void 0 : e.axis) === "y" ? "vertical" : "horizontal"),
        scrollPrev: x,
        scrollNext: I,
        canScrollPrev: S,
        canScrollNext: p,
        hideControlsAtEnds: i
      }),
      [m, u, e, o, x, I, S, p, i]
    );
    return /* @__PURE__ */ Y(en.Provider, { value: w, children: /* @__PURE__ */ Y(
      "div",
      {
        "aria-roledescription": "carousel",
        className: ht(
          T.carousel,
          r === "outside" && T.controlsOutside,
          s && o === "horizontal" && T.edgeFade,
          n
        ),
        "data-can-scroll-next": p,
        "data-can-scroll-prev": S,
        "data-cxy-name": "carousel",
        onKeyDownCapture: L,
        ref: y,
        role: "region",
        ...l,
        children: t
      }
    ) });
  }
);
pe.displayName = "Carousel";
const ge = z.forwardRef(
  ({ className: t, ...n }, r) => {
    const { carouselRef: s, orientation: i } = Ct();
    return /* @__PURE__ */ Y("div", { className: T.carouselViewport, ref: s, children: /* @__PURE__ */ Y(
      "div",
      {
        className: ht(
          T.carouselContainer,
          i === "horizontal" ? T.carouselContainerHorizontal : T.carouselContainerVertical,
          t
        ),
        ref: r,
        ...n
      }
    ) });
  }
);
ge.displayName = "CarouselContent";
const he = z.forwardRef(
  ({ className: t, ...n }, r) => {
    const { orientation: s } = Ct();
    return /* @__PURE__ */ Y(
      "div",
      {
        "aria-roledescription": "slide",
        className: ht(
          T.carouselItem,
          s === "horizontal" ? T.carouselItemHorizontal : T.carouselItemVertical,
          t
        ),
        ref: r,
        role: "group",
        ...n
      }
    );
  }
);
he.displayName = "CarouselItem";
const ye = z.forwardRef(
  ({ className: t, size: n = "icon", variant: r = "outline", ...s }, i) => {
    const { canScrollPrev: e, hideControlsAtEnds: o, orientation: a, scrollPrev: c } = Ct();
    return o && !e ? null : /* @__PURE__ */ Xt(
      Yt,
      {
        className: ht(
          T.carouselControl,
          T.carouselPreviousButton,
          a === "horizontal" ? T.carouselPreviousButtonHorizontal : T.carouselPreviousButtonVertical,
          t
        ),
        disabled: !e,
        onClick: c,
        ref: i,
        size: n,
        variant: r,
        ...s,
        children: [
          /* @__PURE__ */ Y(gn, { className: T.carouselControlIcon }),
          /* @__PURE__ */ Y("span", { className: T.srOnly, children: "Previous slide" })
        ]
      }
    );
  }
);
ye.displayName = "CarouselPrevious";
const Se = z.forwardRef(
  ({ className: t, size: n = "icon", variant: r = "outline", ...s }, i) => {
    const { canScrollNext: e, hideControlsAtEnds: o, orientation: a, scrollNext: c } = Ct();
    return o && !e ? null : /* @__PURE__ */ Xt(
      Yt,
      {
        className: ht(
          T.carouselControl,
          T.carouselNextButton,
          a === "horizontal" ? T.carouselNextButtonHorizontal : T.carouselNextButtonVertical,
          t
        ),
        disabled: !e,
        onClick: c,
        ref: i,
        size: n,
        variant: r,
        ...s,
        children: [
          /* @__PURE__ */ Y(hn, { className: T.carouselControlIcon }),
          /* @__PURE__ */ Y("span", { className: T.srOnly, children: "Next slide" })
        ]
      }
    );
  }
);
Se.displayName = "CarouselNext";
export {
  pe as Carousel,
  ge as CarouselContent,
  he as CarouselItem,
  Se as CarouselNext,
  ye as CarouselPrevious
};
